<template>
  <div class="admin-page">
    <h3>افزودن تگ</h3>
    <div class="admin-form mt-4">
      <div class="admin-tab">
        <custom-input
          kind="text"
          key="7"
          container="half-width ml-3 mt-3"
          classes="full-width"
          v-bind:theModel.sync="tag.name"
          label="نام تگ"
          placeholder="نام"
        ></custom-input>
        <custom-input
          kind="text"
          key="8"
          container="half-width ml-3 mt-3"
          classes="full-width"
          v-bind:theModel.sync="tag.title_seo"
          label="عنوان سئو"
          placeholder="عنوان سئو"
        ></custom-input>
        <custom-input
          kind="text"
          key="9"
          container="half-width ml-3 mt-3"
          classes="full-width"
          v-bind:theModel.sync="tag.slug"
          label="نامک"
          placeholder="نامک"
        ></custom-input>
        <custom-input
          kind="text"
          key="10"
          container="half-width ml-3 mt-3"
          classes="full-width"
          v-bind:theModel.sync="tag.editor"
          label="ادیتور"
          placeholder="ادیتور"
        ></custom-input>
        <custom-input
          kind="text"
          key="11"
          container="half-width ml-3 mt-3"
          classes="full-width"
          v-bind:theModel.sync="tag.meta_desc"
          label="توضیحات متا"
          placeholder="توضیحات متا"
        ></custom-input>

        <div class="add-image mt-4">
          <label class="purple-btn text-center" for="img">انتخاب تصویر</label>
          <input
            type="file"
            class="d-none"
            id="img"
            name="img"
            accept="image/*"
            @change="(e) => updatePic(e)"
          />
          <div class="admin-locker" v-if="img != ''">
            <img :src="img" alt="image" />
          </div>
        </div>
      </div>
      <div class="adminSend">
        <button class="purple-btn" @click="addTag">
          ارسال

          <span v-if="loading" class="mr-2"
            ><v-progress-circular
              :size="20"
              color="primary"
              indeterminate
            ></v-progress-circular
          ></span>
        </button>
      </div>
    </div>
    <!-- <div v-if="edit" class="admin-form mt-3 pt-3 pr-5">
      <p>افزودن نامک</p>
      <custom-input
        kind="text"
        key="11"
        container="half-width ml-3 mt-3"
        classes="full-width"
        v-bind:theModel.sync="tag.slug"
        label="نامک"
        placeholder="نامک"
      ></custom-input>
      <div class="adminSend">
        <button class="purple-btn" @click="addSlug">ارسال</button>
      </div>
    </div> -->
  </div>
</template>
<script>
import CustomInput from "../../Common/CustomInput";
import { ref, computed, inject, onMounted } from "@vue/composition-api";
import Service from "../../../utils/admin-service";

export default {
  components: {
    CustomInput,
  },
  setup(props, context) {
    // component
    const global = inject("global");
    const edit = ref(false);
    const theService = computed(() => {
      return Service(false);
    });
    const img = ref("");
    const pictureFile = ref(null);

    const updatePic = (e) => {
      img.value = URL.createObjectURL(e.target.files[0]);
      pictureFile.value = e.target.files[0];
    };
    onMounted(() => {
      if (context.root.$route.params.id) {
        edit.value = true;
        theService.value.receive(
          "admin/tag/" + context.root.$route.params.id,
          {},
          getTagToEdit,
          failedAdd
        );
      }
    });
    const editTag = ref({});
    const getTagToEdit = async (s, d) => {
      console.log("alizoka");
      tag.value = {
        name: { value: d.data.name, valid: true },
        slug: { value: d.data.slug, valid: true },
        editor: { value: d.data.editor, valid: true },
        title_seo: { value: d.data.title_seo, valid: true },
        meta_desc: { value: d.data.meta_desc, valid: true },
        image: d.data.image,
        id: d.data.id,
        parent_id: { value: d.data.parent_id, valid: true },
      };
      editTag.value = {
        name: { value: d.data.name, valid: true },
        slug: { value: d.data.slug, valid: true },
        editor: { value: d.data.editor, valid: true },
        title_seo: { value: d.data.title_seo, valid: true },
        meta_desc: { value: d.data.meta_desc, valid: true },
        parent_id: { value: d.data.parent_id, valid: true },
        image: d.data.image,
        id: d.data.id,
      };
      console.log("editTag");
      console.log(editTag.value);
      console.log("tag.value");
      console.log(tag.value);

      img.value = d.data.image;
      pictureFile.value = await fetch(img.value).then((r) => r.blob());
      // editTag.value = {
      //   name: { value: d.data.name, valid: true },
      //   image: d.data.image,
      //   id: d.data.id,
      // };
    };
    //form

    const tag = ref({
      name: { value: null, valid: true },
      seo: { value: null, valid: true },
      slug: { value: null, valid: true },
      editor: { value: null, valid: true },
      title_seo: { value: null, valid: true },
      meta_desc: { value: null, valid: true },
      image: null,
    });

    const addTag = () => {
      loading.value = true;
      let f = new FormData();
      if (edit.value) {
        if (
          tag.value.parent_id.value != null &&
          tag.value.parent_id.value != editTag.value.parent_id.value
        )
          f.append("parent_id", parseInt(tag.value.parent_id.value.id));
        if (tag.value.name.value != editTag.value.name.value)
          f.append("name", tag.value.name.value ? tag.value.name.value : "");
        if (tag.value.title_seo.value != editTag.value.title_seo.value)
          f.append(
            "title_seo",
            tag.value.title_seo.value ? tag.value.title_seo.value : ""
          );
        if (tag.value.slug.value != editTag.value.slug.value)
          f.append("slug", tag.value.slug.value ? tag.value.slug.value : "");
        if (tag.value.editor.value != editTag.value.editor.value)
          f.append(
            "editor",
            tag.value.editor.value ? tag.value.editor.value : ""
          );
        if (tag.value.meta_desc.value != editTag.value.meta_desc.value)
          f.append(
            "meta_desc",
            tag.value.meta_desc.value ? tag.value.meta_desc.value : ""
          );
        if (img.value != editTag.value.image)
          f.append("image", pictureFile.value);
      } else {
        f.append("image", pictureFile.value);
        f.append("name", tag.value.name.value);
        f.append("title_seo", tag.value.title_seo.value);
        f.append("slug", tag.value.slug.value);
        f.append("editor", tag.value.editor.value);
        f.append("meta_desc", tag.value.meta_desc.value);
      }
      if (!edit.value)
        theService.value.transmit("admin/tag", f, successfullAdd, failedAdd);
      else {
        theService.value.transmit(
          "admin/tag/" + tag.value.id,
          f,
          successfullAdd,
          failedAdd
        );
      }
    };

    const addSlug = () => {
      let f = new FormData();
      f.append("slug", tag.value.slug.value);
      theService.value.transmit(
        "admin/slug/tag/" + context.root.$route.params.id,
        f,
        successfullAdd,
        failedAdd
      );
    };

    const successfullAdd = (s, d) => {
      if (s == 200) {
        loading.value = false;
        global.alertToggle("با موفقیت افزوده شد!");
        location.reload();
      }
    };

    const failedAdd = (server, e) => {
      loading.value = false;
      var my_errors;
      console.log(e.response.data.error.invalid_params);
      e.response.data.error.invalid_params.forEach((element) => {
        my_errors = my_errors
          ? element.message + " و " + my_errors
          : element.message;
      });
      global.alertToggle(my_errors);
    };
    const loading = ref(null);

    return {
      tag,
      addTag,
      img,
      updatePic,
      addSlug,
      edit,
      failedAdd,
      loading,
      editTag,
    };
  },
};
</script>
<style scoped>
.admin-page {
  padding: 2rem 5rem 2rem 5rem;
}

.admin-tab-bar {
  background-color: #fff;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
}

.admin-tab-bar .active {
  background-color: rgba(127, 127, 127, 0.1);
}

.admin-form {
  border-radius: 8px;
  background-color: rgba(127, 127, 127, 0.1);
  border: 1px solid rgba(127, 127, 127, 0.2);
  min-height: 30vh;
}
.admin-tab-button {
  display: inline-block;
  min-width: 10%;
  padding-top: 1rem;
  margin-left: 3rem;
  padding-right: 1rem;
  padding-left: 1rem;
  text-align: center;
}

.admin-tab {
  padding: 1.5rem 2rem 1.5rem 2rem;
  border-bottom: 1px solid rgba(127, 127, 127, 0.3);
  min-height: 20vh;
}

.adminSend {
  padding: 1.5rem 2rem 1.5rem 2rem;
  text-align: left;
}

.admin-tab-button:hover {
  cursor: pointer;
}

.admin-locker {
  width: 15%;
  margin: 1rem;
  border: 2px dashed #9147ff;
  padding: 0.3rem;
}

.admin-locker img {
  width: 100%;
}
</style>